import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _SvgIcon, _SvgIcon2, _SvgIcon3;
var _excluded = ["checked", "count", "description", "disabled", "indeterminate", "label", "onChange", "readOnly", "size", "touchRippleRef"];
import React, { forwardRef } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCheckbox from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var muiSize = {
  md: 'medium',
  sm: 'small'
};

/**
 * UI component for user interaction - Multiple Selection
 * mui documentation link - https://mui.com/material-ui/react-checkbox/
 */
export var Checkbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    count = props.count,
    description = props.description,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$indeterminate = props.indeterminate,
    indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
    label = props.label,
    onChange = props.onChange,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    _props$size = props.size,
    size = _props$size === void 0 ? 'sm' : _props$size,
    touchRippleRef = props.touchRippleRef,
    others = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "row",
    justifyContent: 'space-between',
    onClick: function onClick(e) {
      return onChange && onChange(e);
    },
    spacing: 2,
    sx: {
      '&:hover': {
        cursor: readOnly || disabled ? 'default' : 'pointer'
      },
      pointerEvents: readOnly || disabled ? 'none' : 'unset'
    },
    children: [/*#__PURE__*/_jsxs(Stack, {
      alignItems: label && description ? 'flex-start' : 'center',
      direction: "row",
      spacing: size === 'sm' ? 2 : 3,
      children: [/*#__PURE__*/_jsx(MuiCheckbox, _extends({
        checked: checked,
        checkedIcon: _SvgIcon || (_SvgIcon = /*#__PURE__*/_jsx(SvgIcon, {
          children: /*#__PURE__*/_jsx(CheckIcon, {})
        })),
        className: readOnly ? 'Mui-readOnly' : '',
        disabled: disabled,
        icon: _SvgIcon2 || (_SvgIcon2 = /*#__PURE__*/_jsx(SvgIcon, {})),
        indeterminate: indeterminate,
        indeterminateIcon: _SvgIcon3 || (_SvgIcon3 = /*#__PURE__*/_jsx(SvgIcon, {
          children: /*#__PURE__*/_jsx(RemoveIcon, {})
        })),
        readOnly: readOnly,
        ref: ref,
        size: muiSize[size],
        sx: {
          marginTop: description && '2px !important'
        }
      }, others)), (label || description) && /*#__PURE__*/_jsxs(Stack, {
        gap: 0.25,
        mt: '-2px',
        children: [label && /*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[700],
          variant: size === 'sm' ? 'text-sm-medium' : 'text-md-medium',
          children: label
        }), description && /*#__PURE__*/_jsx(Typography, {
          color: theme.palette.gray[600],
          variant: size === 'sm' ? 'text-sm-regular' : 'text-md-regular',
          children: description
        })]
      })]
    }), count && /*#__PURE__*/_jsxs(Typography, {
      color: theme.palette.gray[500],
      fontSize: size === 'sm' ? '12px' : '14px',
      lineHeight: '20px',
      children: ["(", count, ")"]
    })]
  });
});